import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import PageContentWrapper from "../../components/PageContentWrapper";
import { Button, Space, Table, Tag } from "antd";
import { getTrainingVideoTraining } from "../../appRedux/actions/TrainingVideo";
import { PlayCircleOutlined } from "@ant-design/icons";
import moment from "moment";

export default function MyRecordedPage() {
  const history = useHistory()
  const [trainings, setTrainings] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getTrainingVideoTraining().then(data => {
      setTrainings(data)
      setLoading(false)
    })
  }, [])

  const getColumns = () => [
    {
      title: '#',
      key: 'index',
      align: "center",
      width: 10,
    },
    {
      title: "Training",
      dataIndex: "training_option",
      render: (training_option, item) => (
        <>
          <Space>
            <Link to={"/training-registration/" + item.id}>{training_option.name}</Link>
          </Space>
        </>
      ),
    },
    {
      title: "Tipe Training",
      dataIndex: "training",
      responsive: ["sm"],
      render: (training, item) => (
        <>
          <Space>
            {item.is_online ? (
              <Tag color="green" style={{ margin: 0 }}>
                ONLINE
              </Tag>
            ) : (
              <Tag color="blue" style={{ margin: 0 }}>
                OFFLINE
              </Tag>
            )}
          </Space>
        </>
      ),
    },
    {
      title: "Jadwal",
      dataIndex: "dates_summary",
      responsive: ["md"],
      render: (dates_summary, item) => (
        <>
          <Space>
            {dates_summary}
            {!item.is_online ? (
              <Tag color="magenta" style={{ margin: 0 }}>
                {item.location}
              </Tag>
            ) : (
              <Tag color="blue" style={{ margin: 0 }}>
                online
              </Tag>
            )}
          </Space>
        </>
      ),
    },
    {
      title: "Batas Waktu Akses Rekaman",
      dataIndex: "show_videos_end",
      responsive: ["md"],
      render: (show_videos_end) => (
        <>
          {moment(show_videos_end).format("dddd, D MMMM YYYY")}
        </>
      ),
    },
    {
      width: 10,
      title: "Action",
      dataIndex: "id",
      render: (id) =>
      (
        <Button
          icon={<PlayCircleOutlined />}
          type="primary"
          onClick={() => history.push("/my-recorded/" + id)}
        >
          Lihat
        </Button>
      ),
    },
  ];

  return <PageContentWrapper title="Rekaman Kelas">
    <Table
      size="small"
      dataSource={trainings.map((t) => ({ ...t, key: t.id }))}
      loading={loading}
      columns={getColumns()}
    />
  </PageContentWrapper>
}
